import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cn from 'classnames';
import css from './css.css';
import SimpleDialog from "~/components/SimpleDialog/SimpleDialog";

import { Center, IconButton, ZStack, } from "~/native-ui"
import { HStack } from 'native-base';

const NavButton  = ({direction, title, changeIndex, ...otherProps}) => {
	let amount = 1,
		icon = 'keyboard-arrow-right';

	if(direction === 'prev') {
		amount = -1;
		icon = 'keyboard-arrow-left';
	}

	return (
                <IconButton
					{ ...otherProps }
                    type={icon}
                    ripple={false}
					onClick={() => changeIndex(amount)}
                    className={cn(css.overlayButton, css.navigationButton)}
                />
	);
};

export default class DialogGallery extends Component {
	static propTypes = {
        activeIndex: PropTypes.number.isRequired,
		autoHideNavigation: PropTypes.bool.isRequired,
		captions: PropTypes.array.isRequired,
		upperBound: PropTypes.number,
		lowerBound: PropTypes.number,
	};

	static defaultProps = {
        upperBound: null,
        lowerBound: null,
		activeIndex: 0,
		autoHideNavigation: true,
        captions: {},
	};

    componentDidMount() {
    }

    getLowerBound = () => {
        if(this.props.lowerBound !== null) { return this.props.lowerBound; }
        return 0;
	};

    getUpperBound = () => {
        if(this.props.upperBound !== null) { return this.props.upperBound; }
        return React.Children.count(this.props.children)-1;
	};

	getActiveItem = () => {
        return React.Children.map(this.props.children, (child, index) => {
        	if(this.props.activeIndex === index) {
                return React.cloneElement(child, { maxHeight:"100%", active: !this.props.preload });
			}

			return null;
            // return React.cloneElement(child, { maxHeight:"100%", active: false, className: cn(css.item, css.hiddenItem, child.props.className) });
		});
	};

	getNewIndex = (number) => {
		let newIndex = this.props.activeIndex+number,
			maxIndex = this.getUpperBound();

		if(newIndex > maxIndex) {
			return this.getLowerBound();
		}

		if(newIndex < this.getLowerBound()) {
			return maxIndex;
		}

		return newIndex;
	};

	changeIndex = (number) => {
		let newIndex = this.getNewIndex(number);
		this.props.onChange?.(newIndex);
	};

	render() {
		let props = this.props;

		let showPrevNavigation = false,
			showNextNavigation = false;


        let { activeIndex, captions } = this.props;

		if(props.autoHideNavigation) {
			showPrevNavigation = (activeIndex-1) >= this.getLowerBound();
			showNextNavigation = (activeIndex+1) <= this.getUpperBound();
        }

		let prevCaption  = showPrevNavigation ? captions[activeIndex-1] : '',
			nextCaption  = showNextNavigation ? captions[activeIndex+1] : '';

		return (
			<SimpleDialog
				type={this.props.type}
				active={this.props.active || this.props.preload}
				preload={this.props.preload}
                onEscKeyDown={props.onEscKeyDown ? props.onEscKeyDown : props.onClose}
                onOverlayClick={props.onOverlayClick ? props.onOverlayClick : props.onClose}

			>
				{/* // DEV_NOTE: Revisit */}
					<ZStack maxHeight="80%" height={400} my="auto">
						<Center h="100%" w="100%">
							{this.getActiveItem()}
						</Center>

						<Center h="100%" w="100%">
							<HStack w="100%">
								{showPrevNavigation && <NavButton mr="auto" title={prevCaption} changeIndex={this.changeIndex} direction="prev" />}
								{showNextNavigation && <NavButton ml="auto" title={nextCaption} changeIndex={this.changeIndex} direction="right" />}
							</HStack>
						</Center>
					</ZStack>
            </SimpleDialog>
		);
	}
}